import(/* webpackMode: "eager" */ "/frontend/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/frontend/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(client-components)/(HeroSearchForm)/HeroSearchForm.tsx");
import(/* webpackMode: "eager" */ "/frontend/src/components/SectionSliderNewCategories.tsx");
import(/* webpackMode: "eager" */ "/frontend/src/components/SectionSubscribe2.tsx");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-1.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-10.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-11.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-12.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-13.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-14.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-15.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-16.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-17.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-18.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-19.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-2.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-20.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-3.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-4.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-5.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-6.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-7.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-8.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/avatars/Image-9.png");
import(/* webpackMode: "eager" */ "/frontend/src/images/hero-right2.png");
import(/* webpackMode: "eager" */ "/frontend/src/shared/Avatar.tsx");
import(/* webpackMode: "eager" */ "/frontend/src/shared/Button.tsx");
import(/* webpackMode: "eager" */ "/frontend/src/shared/ButtonSecondary.tsx")